export const REACTPV_IMPRESSIONS = {
    CATEGORY: '@REACTPV_Category',
    CART: '@REACTPV_Cart',
    HOMEPAGE: '@REACTPV_Homepage',
    PRODUCT: '@REACTPV_Product',
    BLOG: '@REACTPV_Blog',
    CHECKOUT: '@REACTPV_Checkout',
    'ORDER SUCCESS': '@REACTPV_Order success',
    CONFIGURE: '@REACTPV_CartEdit',
    MY_ACCOUNT: '@REACTPV_myAccount',
    MY_PICKS: '@REACTPV_myPicks',
    CHANGE_FORGOTTEN: '@REACTPV_ChangeForgotten',
    DEFAULT: '@REACTPV_otherPages',
};
